<template>
    <ui-icon v-bind:style="{fontSize:'1.5em'}" v-on:click.native.stop.prevent="toggleDrawerMenu()" class="icon" backgroundColor="#DDDDDD" color="#666666" icon="bars"></ui-icon>
</template>

<script>

import UiIcon from '../UiIcon.vue'
import { eventBus } from '../../services/EventBus.js';


export default {
  name: 'icon-button-hamburger',
  props:{
  },
  data:function(){
    return {
    }
  },
  methods:{
    toggleDrawerMenu(){
      eventBus.$emit('toggleDrawerMenu');
    }
  },
  mounted:function(){
    
  },
  components:{
    UiIcon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
  cursor:pointer
}
</style>
